"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _framerMotion = require("framer-motion");
var _themeProvider = require("../../../../theme/themeProvider/index.js");
var _interface = require("../interface.js");
var _CheckBoxComponent = require("./CheckBoxComponent.js");
var _jsxRuntime = require("react/jsx-runtime");
const StyledCheckMark = props => {
  const theme = (0, _themeProvider.useTheme)();
  const {
    isChecked,
    color,
    bgColor,
    borderColor,
    size,
    borderRadius,
    isHovered,
    disabled,
    icon,
    unCheckedIcon,
    inActiveColor,
    inActiveBorderColor,
    checkBoxDimensions,
    defaultBgColor = 'transparent',
    hoverBgColor = 'transparent',
    tickIconColor = 'white',
    activeBorderColor = theme.color.primary,
    hoverBorderColor = theme.color.primary,
    disabledStateBorderColor = theme.color.primary,
    defaultBorderWidth = 2,
    hoverBorderWidth = 2,
    activeBorderWidth = 2,
    borderStyle = 'solid'
  } = props;
  let checkBoxSize = '20px';
  let checkBoxBorderColor = borderColor;
  let checkBoxBgColor = defaultBgColor;
  let checkBoxBorderRadius = borderRadius;
  let tickColor = 'transparent';
  const variable = theme?.variables;
  switch (size) {
    case _interface.CheckBoxInputSize.large:
      checkBoxSize = '30px';
      // checkBoxBorderRadius = variable.checkBoxLargeBorderRadius;
      break;
    case _interface.CheckBoxInputSize.small:
      checkBoxSize = '18px';
      // checkBoxBorderRadius = variable.checkBoxSmallBorderRadius;
      break;
  }
  if (isChecked) {
    checkBoxBorderColor = activeBorderColor;
    checkBoxBgColor = bgColor;
    tickColor = color;
  } else if (!isChecked && unCheckedIcon) {
    checkBoxBorderColor = inActiveBorderColor;
    checkBoxBgColor = inActiveColor;
  } else if (isHovered) {
    checkBoxBorderColor = hoverBorderColor;
    checkBoxBgColor = hoverBgColor;
    tickColor = color;
  } else if (disabled) {
    checkBoxBorderColor = disabledStateBorderColor;
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_CheckBoxComponent.StyledSpan, {
    width: checkBoxSize,
    height: checkBoxSize,
    background: checkBoxBgColor,
    borderRadius: checkBoxBorderRadius,
    borderColor: checkBoxBorderColor,
    hoverBorderColor: hoverBorderColor,
    tabIndex: 0,
    disabled: !!disabled,
    checkBoxDimensions: checkBoxDimensions,
    defaultBorderWidth: defaultBorderWidth,
    hoverBorderWidth: hoverBorderWidth,
    activeBorderWidth: activeBorderWidth,
    borderStyle: borderStyle,
    children: [isChecked && (icon === 'minus' ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_framerMotion.m.svg, {
      initial: false,
      width: '18px',
      height: '18px',
      viewBox: "0 0 24 24",
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_framerMotion.m.line, {
        fill: "none",
        x1: "4.03029",
        y1: "12",
        x2: "21.96969",
        y2: "12",
        id: "svg_1",
        stroke: color,
        strokeWidth: "2px"
      })
    }) : /*#__PURE__*/(0, _jsxRuntime.jsx)("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      width: "12",
      height: "9",
      viewBox: "0 0 12 9",
      fill: "none",
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
        d: "M0.800781 4.5999L4.40078 8.1999L11.2008 1.3999",
        stroke: tickIconColor,
        "stroke-linecap": "square"
      })
    })), !isChecked && unCheckedIcon && /*#__PURE__*/(0, _jsxRuntime.jsx)("img", {
      src: unCheckedIcon
    })]
  });
};
var _default = exports.default = StyledCheckMark;
module.exports = exports.default;
module.exports.default = exports.default;